import React, { useEffect, useRef } from 'react';
import { geoConicConformal, geoPath } from 'd3-geo';
import { select } from 'd3-selection';
import { useSelector, useDispatch } from 'react-redux';
import colors from '../../vars/colors.json';
import MapSelectionLabel from './MapSelectionLabel';
import useConfig from '../../hooks/use-config';
import { filtersActions } from '../../../apps/regionalAnalysis/store/filters';

const Minimap = () => {
  const dispatch = useDispatch();
  const currentMapSelection = useSelector((state) => state.filters.mapSelection);
  const currentRegion = useSelector((state) => state.filters.region);




  let activeMapRegion = '11';
  /*
  BEGIN C&P PART
  This part was taken 1:1 from the original app and was not refactored
 */
  let bayernShape = null;
  let geopath = null;

  const selectRegionOnMap = (activeNode, regionName) => {
    const selection = select('path.regionActive');
    const selectedNode = selection.node();

    selection.style('fill', colors.themeBase.box);
    selectedNode?.classList.remove('regionActive');

    if (activeNode && activeNode.getAttribute('dataname') === regionName) {
      const newSelection = select(activeNode);

      newSelection.attr('class', 'regionActive');
      newSelection.style('fill', colors.themeBase.accentDark);
    }
  };

  const buildMinimap = (region, minimapSvgRef) => {
    // GeoJSON Features Indizes von bis der jeweiligen Region
    const regionConfig = {
      bavaria: { idFrom: 11, idTo: 11 },
      govregion: { idFrom: 12, idTo: 18 },
      county: { idFrom: 19, idTo: 47 },
      climaregion: { idFrom: 119, idTo: 125 },
      nature: { idFrom: 1, idTo: 4 },
      default: { idFrom: 11, idTo: 11 },
    };
    const { idFrom, idTo } = regionConfig[region];
    const svgWidth = 273;
    const svgHeight = 300;
    const svgPaddingTop = 15;
    const svgPaddingBottom = 25;

    // Je nach ausgewählter Region werden hier nur die zu betrachtenden Features hinein gefügt
    let filteredShape;
    const filterShapes = () => {
      const filtered = bayernShape.features.filter(
        (feature) =>
          feature.properties.OBJECTID >= idFrom &&
          feature.properties.OBJECTID <= idTo
      );
      // DeepCopy der Ursprungsdatei
      filteredShape = JSON.parse(JSON.stringify(filtered));
      // TODO Marc prüfen, welches winding der Geometrie vorliegt, damit das reverse & DeepCopy erspart bleibt
      // Momentan Umkehren des Koordinaten Arrays, da d3 die Koordinaten im Uhrzeigersinn erwartet, was
      // konträr zum RFC 7946 steht
      filteredShape.forEach((elem) => elem.geometry.coordinates[0].reverse());
      // dispatch(dataActions.setFilteredShape(filteredShape));
      // if (!initialized) {
      //   dispatch(dataSecondLvlActions.applyFilteredShape(filteredShape));
      //   initialized = true;
      // }
    };

    /**
     * Anhand des geopath werden aus Koordinaten svg Zeichenbefehle generiert
     */
    const buildGeoPath = () => {
      // Projektion anhand von ganz Bayern - Bayern gesamt muss an Index 10 liegen
      // Für Minimap ist hier statisch Index 10 Interessant, da nicht an Features "gezoomt" werden soll
      const bayernShapeReversed = JSON.parse(
        JSON.stringify(bayernShape.features[10])
      );
      bayernShapeReversed.geometry.coordinates[0].reverse();
      const projection = geoConicConformal()
        .parallels([35, 65])
        .rotate([-10, 0])
        .fitSize(
          [svgWidth, svgHeight - svgPaddingTop - svgPaddingBottom],
          bayernShapeReversed
        );

      geopath = geoPath(projection);
    };

    /**
     * @returns DOM-Node von SVG
     */
    const createSVG = () => {
      const svgNode = minimapSvgRef.current;
      const svgSelection = select(svgNode);

      if (!svgNode.querySelector('defs')) {
        svgSelection.attr('viewBox', `0 0 ${svgWidth} ${svgHeight}`);

        const defs = svgSelection.append('defs');

        defs
          .append('path')
          .attr('class', 'outline')
          .attr('d', geopath({ type: 'Sphere' }));

        defs
          .append('clipPath')
          .attr('class', 'clip')
          .append('use')
          .attr('href', new URL('#outline', window.location));

        svgSelection.append('g');
      } else {
        // Entferne alte Regionen aus der Minimap
        svgSelection.selectAll('path').remove();
      }
      return svgSelection;
    };

    const drawMinimap = () => {
      const svg = createSVG();

      // Das Layer des SVGs, auf dem die Regionen gezeichnet werden sollen
      const regionsLayer = svg.select('g');

      regionsLayer
        .selectAll('path')
        .data(filteredShape)
        .enter()
        .append('path')
        .attr('d', geopath)
        .attr('dataname', (d) => d.properties.Name)
        .attr('dataid', (d) => d.properties.OBJECTID)
        .attr('id', (d) => d.properties.OBJECTID)
        .attr('transform', `translate(0, ${svgPaddingTop})`)
        .on('click', (event) => {
          activeMapRegion = event.target.attributes.dataname.value;
          selectRegionOnMap(event.target, activeMapRegion);

          const mapSelection = parseInt(
            event.target.attributes.dataid.value,
            10
          );
          dispatch(
            filtersActions.changeMapSelection({
              label: activeMapRegion,
              value: mapSelection,
            })
          );
          // on click action here
          // console.log(`region: ${activeMapRegion}`);
        })
        .on('mouseover', (event) => {
          select(event.target).style('fill', colors.themeBase.accentDark);
        })
        .on('mouseout', (event) => {
          select(event.target).style('fill', colors.themeBase.box);
          select('path.regionActive').style(
            'fill',
            colors.themeBase.accentDark
          );
        })
        .style('fill', colors.themeBase.box)
        .style('stroke', colors.themeBase.accentDark)
        .style('stroke-linejoin', 'round')
        .style('stroke-width', '1px');

      // const { activeRegion, regionName } = this.state;

      if (currentMapSelection) {
        selectRegionOnMap(
          document.querySelector(`path[dataid="${currentMapSelection.value}"]`),
          currentMapSelection.label
        );
      }
    };
    /*
      END C&P PART
     */

    buildGeoPath();
    filterShapes();
    drawMinimap();
  };

  const minimapSvgRef = useRef(null);
  const activeRegion = currentRegion.value;

  const fullShape = useSelector((state) => state.data.fullShape);
  const { getBayernGeo } = useConfig();

  useEffect(() => {
    const transformBayernGeo = (mapdata) => {
      bayernShape = mapdata;
      // dispatch(dataActions.setFullShape(bayernShape));
      buildMinimap(activeRegion, minimapSvgRef);
    };
    if (!fullShape) {
      getBayernGeo(transformBayernGeo, activeRegion);
    } else {
      bayernShape = fullShape;
      buildMinimap(activeRegion, minimapSvgRef);
    }
  }, [activeRegion]);

  return (
    <div className="minimap-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="minimapShape"
        id="minimapShape"
        ref={minimapSvgRef}
      />
      <MapSelectionLabel />
    </div>
  );
};

export default Minimap;
